import { render, staticRenderFns } from "./business-details.vue?vue&type=template&id=82a8a646&"
import script from "./business-details.vue?vue&type=script&lang=ts&"
export * from "./business-details.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../16/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports